import _ from 'lodash'

const asyncDispatcher = (
  dispatch,
  { action, data, pending, success, failure }
) => {
  const dispatchPending = () => {
    typeof pending !== 'undefined' && dispatch({ type: pending, data });
  };

  const handleSuccess = (response) => {
    const payload = { ...data, ...response };
    _.flatten([success]).forEach(actionType => {
      dispatch({ type: actionType, data: payload });
    });
    return payload;
  };

  const handleFailure = (error) => {
    dispatch({ type: failure, data: { ...data, error } });
    throw error;
  };

  return Promise.resolve()
    .then(dispatchPending)
    .then(() => Promise.resolve(action))
    .then(handleSuccess)
    .catch(handleFailure)
};

export default asyncDispatcher;



// WEBPACK FOOTER //
// ./src/utils/asyncDispatcher.js